/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";

interface IProps {
    src: string;
    fallbackSrc?: string;
    className?: string;
    alt?: string;
    style?: React.CSSProperties;
}

export function LazyImage(props: IProps) {
    const { src, className, style, alt, fallbackSrc } = props;

    const ref = useRef<HTMLImageElement>(null);
    const [visible, setVisible] = useState(false);

    function isInViewport(element: HTMLElement) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function onScroll() {
        if (!ref.current) return;
        if (visible) return;
        if (isInViewport(ref.current))
            setVisible(true);
    }

    useEffect(() => {
        onScroll(); // immediate init
        document.addEventListener('scroll', onScroll, { passive: true });
        return () => document.removeEventListener('scroll', onScroll)
    }, [ref])

    return (<img ref={ref} key={visible ? src : fallbackSrc} src={src} className={className} style={style} alt={alt} />)
}